import { BlockThreeColumn } from '@dreamstack/payload/src/payload-types'
import first from 'lodash/first'
import type { FunctionComponent } from 'react'
import { ChildrenBlockSpacingContainer } from '../contentful/ChildrenBlockSpacingContainer'
import { ContentfulBlocks } from '../contentful/ContentfulBlocks'
import AnalystRatings from './AnalystRatings/AnalystRatings'

export const ThreeColumnLayout: FunctionComponent<
  React.PropsWithChildren<{
    block: BlockThreeColumn
  }>
> = ({ block }) => {
  // TODO: WIP
  const showArrow =
    first(block?.leftColumn ?? [])?.blockType === 'blockAnalystRating'

  if (showArrow) {
    return (
      <AnalystRatings
        blocks={[
          ...(block?.leftColumn ?? []),
          ...(block?.middleColumn ?? []),
          ...(block?.rightColumn ?? []),
        ]}
      />
    )
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-px-48">
      <ChildrenBlockSpacingContainer>
        <ContentfulBlocks blocks={block.leftColumn ?? []} />
      </ChildrenBlockSpacingContainer>
      <ChildrenBlockSpacingContainer>
        <ContentfulBlocks blocks={block.middleColumn ?? []} />
      </ChildrenBlockSpacingContainer>
      <ChildrenBlockSpacingContainer>
        <ContentfulBlocks blocks={block.rightColumn ?? []} />
      </ChildrenBlockSpacingContainer>
    </div>
  )
}
